import React from 'react';
import EnvironmentSelector from './EnvironmentSelector';

export default function Header() {
  return (
    <header
      className="bg-cloud-white border-b border-storm-blue/20 px-6 py-4 shadow-sm"
      style={{
        background: 'linear-gradient(180deg, #E0E1DD 0%, #d5d7d3 100%)',
      }}
    >
      <div className="flex items-center justify-between">
        {/* Left section - Logo + Branding */}
        <div className="flex items-center gap-3">
          <img
            src="/logos/Flock_Icon.svg"
            alt="Flock"
            className="w-10 h-10"
          />
          <div>
            <h1 className="text-[20px] leading-[1.2] font-semibold text-deep-navy">
              The Fold
            </h1>
            <p className="text-[12px] leading-[1.4] text-storm-blue">
              Flock Operations
            </p>
          </div>
        </div>

        {/* Right section - Environment indicator */}
        <div className="flex items-center gap-3">
          <span className="text-[14px] leading-[1.5] text-storm-blue">
            Connected to:
          </span>
          <EnvironmentSelector />
        </div>
      </div>
    </header>
  );
}
